import { useState } from 'react'

import { Box, Button, Icon, Input, Text } from '@fairfashion/design-system'

import * as Styles from './tags-input.styles'
import { TagsInputProps } from './tags-input.types'

export const TagsInput = ({
  value,
  label,
  onChange,
  placeholder,
  disabled,
}: TagsInputProps) => {
  const [text, setText] = useState('')

  const handleAdd = () => {
    if (text) {
      onChange([...value, text])
      setText('')
    }
  }

  return (
    <Box width="100%" direction="column">
      <Input
        width="100%"
        placeholder={placeholder}
        label={label}
        value={text}
        onChange={(e) => setText(e.target.value)}
        adornment={
          <Button
            padding="2px"
            onClick={handleAdd}
            borderRadius="6px"
            disabled={disabled}
          >
            <Icon name="add" color="white" />
          </Button>
        }
        disabled={disabled}
        adornmentPosition="right"
      />
      <Box flexWrap="wrap" width="100%" gap={1} marginTop={1}>
        {value.map((tag, index) => (
          <Styles.TagContainer
            borderRadius="16px"
            padding={1}
            backgroundColor="grey_5"
            direction="row"
            gap={1}
            alignItems="center"
            key={`tag-${index}`}
          >
            <Text size="small">{tag}</Text>
            <Button
              padding="0"
              variant="text"
              onClick={() => onChange(value.filter((_, i) => i !== index))}
              disabled={disabled}
            >
              <Icon name="close" color="grey_2" />
            </Button>
          </Styles.TagContainer>
        ))}
      </Box>
    </Box>
  )
}
